import "./style.css";
import { useState } from 'react';
import { vehicleStatusLocationsApiUrl } from "components/Common/endpoints";
import { ROUTES } from "components/Common/Constants";
import { Card, Col, Row, Select } from "antd";
import MarkerMap from 'components/Common/Maps/MarkerMap';

import { VEHICLE_STATUS } from "./constants";
import { useFetchLive } from "hooks/useFetchLive";

const { Option } = Select;

const LocationsCard = () => {
    const [selectedStatus, setSelectedStatus] = useState('All');
    const {data,} = useFetchLive(vehicleStatusLocationsApiUrl);

    const statusChange = (value) => {
        setSelectedStatus(value);
    }

    let mapData=[];
    if (data) {
        if (selectedStatus !== 'All') {
            const layer = VEHICLE_STATUS.filter(status => status.name === selectedStatus)
            const statusData = data?.vehicles[selectedStatus.toUpperCase()].map((d) => {
                return ({
                    id: d.imei,
                    position: [d.latitude, d.longitude],
                    label: d.imei,
                })
            });
            mapData = [{
                status: selectedStatus,
                statusData,
                markerColor: layer[0].markerColor
            }]
        } else {
            mapData = VEHICLE_STATUS.map((status, index) => {
                const layer = data?.vehicles[status.name.toUpperCase()]?.map((d)=>{
                    return ({
                        id: d.imei,
                        position: [d.latitude, d.longitude],
                        label: d.imei,
                    })
                });
                const resp = {
                    status: status.name,
                    statusData : layer,
                    markerColor: status.markerColor
                }
                return resp
            }); 
        }
    }      
    
    return(
        <Card             
            bordered={false}
            className="locations-card"
            title={
              <Row className="distance-card-title">
                <Col span="8"><span>Location</span></Col>
                <Col span="16" style={{ textAlign: "right" }}justify="end">
                  <div>
                    <Select defaultValue="All" className="location-dropdown" onChange={statusChange}>
                        <Option key={0} value={'All'}></Option>
                        {VEHICLE_STATUS.map((status, index)=>{
                            return(
                                <Option 
                                    key={index+1} 
                                    value={status?.name}
                                >
                                    {status?.name.charAt(0).toUpperCase() + status?.name.slice(1)}
                                </Option>
                            )
                        })}
                    </Select>
                  </div>
                </Col>
              </Row>
            } >
            <Row>
                <Col span={24} style={{borderRadius: '8px'}}>
                    <MarkerMap height={474} layerData={mapData} navigateUrl={ROUTES.VEHICLE_ANALYTICS.link}/>
                </Col>
            </Row>
        </Card>
    );
};

export default LocationsCard;